export default {
    visibilityFilter: 'Sichtbarkeit',
    placeholderSearch: 'Search',
    teamFilter: 'Teams',
    stateSelect: 'Status',
    minValue: 'Von',
    maxValue: 'Bis',
    search: 'Textsuche',
    placeholder: 'Suchtext eingeben',
    app: 'App',
    webapp: 'Webapp',
    assembly: '3D Gruppe',
    model: '3D Element',
    helper: 'vHelper',
    tbl: 'Tabelle',
    obj: 'Objekt',
    sensor: 'Sensor',
    feed: 'Feed',
    typeSelect: 'Typ',
    tagFilter: 'Tags',
    orgFilter: 'Organisationen',
    fieldSelector: 'Feld filtern',
    all: 'Alle',
    none: 'Keine',
    private: 'Privat',
    public: 'Öffentlich',
    global: 'Global',
}